const faq =
    [
        {
            id: 1,
            question: 'Lorem ipsum dolor sit amet consectetur. Urna faucibus volutpat ',
            answer: 'Lorem ipsum dolor sit amet consectetur. Nullam in urna non aenean condimentum tempus sollicitudin commodo. Cursus luctus sapien auctor placerat bibendum vitae egestas nunc vulputate. Vitae turpis quisque non ipsum mollis neque.',
        },

        {
            id: 2,
            question: 'Lorem ipsum dolor sit amet consectetur. Arcu sit vitae sed ultricies sit non id.',
            answer: 'Lorem ipsum dolor sit amet consectetur. Nullam in urna non aenean condimentum tempus sollicitudin commodo. ',
        },
        {
            id: 3,
            question: 'Lorem ipsum dolor sit amet consectetur',
            answer: 'Lorem ipsum dolor sit amet consectetur. Nullam in urna non aenean condimentum tempus sollicitudin commodo. ',
        },
        {
            id: 4,
            question: 'Lorem ipsum dolor sit amet consectetur. Metus egestas sed aenean nunc et enim.',
            answer: 'Lorem ipsum dolor sit amet consectetur. Nullam in urna non aenean condimentum tempus sollicitudin commodo. Cursus luctus sapien auctor placerat bibendum vitae egestas nunc vulputate. Vitae turpis quisque non ipsum mollis neque.',
        },
    ]

export default faq;